var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 0.833374C4.93717 0.833374 0.833008 4.93754 0.833008 10C0.833008 15.0625 4.93717 19.1667 9.99967 19.1667C15.0622 19.1667 19.1663 15.0625 19.1663 10C19.1663 4.93754 15.0622 0.833374 9.99967 0.833374ZM13.973 8.45004C14.0462 8.36641 14.1019 8.26899 14.1368 8.16351C14.1718 8.05804 14.1853 7.94664 14.1766 7.83586C14.1678 7.72509 14.137 7.61718 14.086 7.51848C14.0349 7.41978 13.9647 7.3323 13.8793 7.26116C13.7939 7.19002 13.6952 7.13668 13.5889 7.10426C13.4826 7.07184 13.3709 7.06101 13.2604 7.0724C13.1499 7.08379 13.0427 7.11716 12.9453 7.17057C12.8479 7.22397 12.7621 7.29633 12.693 7.38337L9.10968 11.6825L7.25551 9.82754C7.09834 9.67574 6.88784 9.59175 6.66934 9.59365C6.45084 9.59554 6.24183 9.68319 6.08733 9.83769C5.93282 9.9922 5.84518 10.2012 5.84328 10.4197C5.84138 10.6382 5.92538 10.8487 6.07718 11.0059L8.57718 13.5059C8.65906 13.5877 8.75709 13.6516 8.86502 13.6934C8.97295 13.7353 9.08842 13.7542 9.20407 13.7489C9.31971 13.7437 9.43299 13.7144 9.53668 13.6629C9.64038 13.6115 9.73222 13.539 9.80634 13.45L13.973 8.45004Z",
    fill: "#0A71BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckCircle);
export default __webpack_public_path__ + "static/media/blue-check-circle.c37d4fb6afce63015d3a989e57b769d2.svg";
export { ForwardRef as ReactComponent };